<script setup>
import Navbar from "./components/layout/navbar.vue";
import {watch, computed, ref} from "vue";
import store from "./store";
import {usePrintDetection} from "@/lib/usePrintDetection";

const {printing} = usePrintDetection()

const modal = computed(() => {
  return store.getters.activity_alt('modal-shown', true)
})

const overlay = ref(false)

watch(printing, (v) => store.state.printing = v)

watch(() => store.getters.activity, (v) => {
  if (v)
    overlay.value = true
  else
    setTimeout(() => overlay.value = false, 150)
}, {immediate: true})
</script>

<template>
  <b-overlay :show="$store.getters.activity && !modal" spinner-variant="danger" opacity="0.4" class="h-100">
    <div :class="$store.state.printing ? '' : 'd-flex flex-column h-100 main'">
      <b-overlay :opacity="0" spinner-type="none" :show="overlay" z-index="12"
                 v-if="!$route.meta.nonav && $store.getters.isAuthenticated && !$store.getters.is_first">
        <navbar fixed="none" :style="overlay && 'z-index: 11'"/>
      </b-overlay>
      <vue-page-transition name="fade-in-up" :class="$store.state.printing ? 'overflow-visible' : 'd-flex flex-column flex-fill overflow-auto'" id="content">
        <router-view :key="$route.fullPath"/>
      </vue-page-transition>
    </div>
  </b-overlay>
</template>


<style>
</style>